import { CatList } from '@blocks-react/components/List';
import { FC } from 'react';
import { HeaderCartListItem, HeaderCartListItemSkeleton } from './item';
import { CartListItem, HeaderCartListProps } from './types';

const skeletons = [...new Array(5).keys()];

export const HeaderCartList: FC<HeaderCartListProps> = ({
  items,
  quantityLabel,
  isLoading,
  onItemClick
}) => {
  return (
    <CatList>
      {isLoading
        ? skeletons.map((key) => (
            <HeaderCartListItemSkeleton key={`cart-list-item-${key}`} />
          ))
        : items.map((item: CartListItem, index: number) => (
            <HeaderCartListItem
              item={item}
              key={item.orderItemId}
              quantityLabel={quantityLabel}
              onClick={() => onItemClick(item, index)}
            />
          ))}
    </CatList>
  );
};
